import { Box, IconButton, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { DaysWeek } from '../../utils/enums/tabs';
import { useStyles } from './styles';


const daysOfWeek = [
    { label:'L', value: DaysWeek.MONDAY },
    { label:'M', value: DaysWeek.TUESDAY },
    { label:'W', value: DaysWeek.WEDNESDAY },
    { label:'J', value: DaysWeek.THURSDAY },
    { label:'V', value: DaysWeek.FRIDAY },
    { label:'S', value: DaysWeek.SATURDAY },
    { label:'D', value: DaysWeek.SUNDAY },
]

export const DayOfWeekPicker = ({ selectedDay, setSelectedDay }: { selectedDay: number | undefined, setSelectedDay: Dispatch<SetStateAction<number | undefined>> }) => {
  // Almacena el día seleccionado

  const handleDayClick = (index:number) => {
    setSelectedDay(index); // Actualiza el estado con el día seleccionado
  };

  const styles = useStyles()


  return (
    <Box display="flex" justifyContent="center" gap={2} mt={4}>
      {daysOfWeek.map(day => (
        <IconButton
          key={day.value}
          onClick={() => handleDayClick(day.value)}
          sx={styles.daysOfWeek(selectedDay === day.value)}
        >
          <Typography variant="h6" fontWeight="bold">
            {day.label}
          </Typography>
        </IconButton>
      ))}
    </Box>
  );
};

